<template>
    <div class="container" data-contract-company="tflain" data-html-name="대부거래 표준약관">
        <!-- contract : 계약서 / manual : 설명서 -->
        <div class="manual">

            <header-black>
                <template #backBtn>
                    <button class="backBtn_icon"></button>
                </template>
                <div slot="title">대부거래 표준약관</div>
            </header-black>

            <main class="bottom_btn_case">
                <section class="default">

                    <article class="terms_article logo_and_title">
                        <div class="FTC_img"></div>

                        <div>
                            표준약관 제10036호<br/>
                            (2019. 5. 15. 개정)
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제1조 (목적)</div>
                        <div>
                            이 약관은 대부업자와 채무자간의 대부거래에 있어서 권리와 의무를 명확히 하고 공정하며 건전한 금전소비대차를 하는 것을 목적으로 한다.
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제2조 (적용범위)</div>
                        <div>이 약관은 대부업자와 채무자 사이의 가계 또는 기업의 자금대부 또는 그 중개 및 어음할인 등의 금전의 대부와 관련된 대부업자와 채무자 사이의 모든 거래에
                            적용된다.
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제3조(용어의 정의)</div>

                        <div>이 약관에서 사용하는 용어의 정의는 다음과 같다.</div>

                        <div>
                            <div class="flex">
                                <div class="alphabet_align">1.</div>
                                <div>“대부업”이라 함은 금전의 대부 또는 그 중개, 금전의 대부와 관련한 어음의 할인 및 이와 유사한 방법에 의한 금전의 교부와 관련된 사항을 그 업으로
                                    행하는 사업을 말한다.
                                </div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">2.</div>
                                <div>“대부업자”라 함은 관할관청에 등록여부를 불문하고 대부업을 영위하는 개인 및 법인으로 한다.</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">3.</div>
                                <div>“채무자”라 함은 대부계약의 체결로 인하여 대부업자에 대하여 채무를 부담하는 자를 말한다.</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">4.</div>
                                <div>“보증인”이라 함은 채무자가 채무를 이행하지 않는 경우에 그 채무를 대신 이행할 종(從)된 채무를 부담하는 자를 말한다.</div>
                            </div>
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제4조(실명거래)</div>
                        <div>
                            ① 대부업자와 채무자 사이의 거래는 실명으로 한다.<br/>
                            ② 대부업자는 채무자가 본인임을 확인할 의무가 있다.<br/>
                            ③ 대부업자와 채무자 사이의 계약은 채무자 본인이 직접 체결하는 것을 원칙으로 하되, 채무자의 대리인과 계약을 체결하는 경우에는 채무자가 발급받은 인감증명서 또는
                            본인서명사실확인서(또는 전자본인서명사실확인서 발급증)를 첨부한 위임장에 의하여야 한다.
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제5조(약관의 명시·설명·교부)</div>
                        <div>
                            ① 대부업자는 이 약관을 영업장에 비치하고, 채무자는 영업시간 중 언제든지 이를 열람하거나 그 교부를 청구할 수 있다.<br/>
                            ② 대부업자는 계약체결 전에 이 약관 제7조를 포함한 중요내용을 채무자가 이해할 수 있도록 설명하고 약관을 교부한다.
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제6조(계약의 성립)</div>
                        <div>대부업자가 약관의 내용을 설명하고 채무자가 본 계약서에 의하여 이의 적용을 동의한 경우 계약은 성립한다.</div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제7조(계약서 필수기재사항)</div>
                        <div>대부거래 표준계약서에는 다음의 사항을 반드시 기재한다.</div>
                        <div>
                            <div class="flex">
                                <div class="alphabet_align">1.</div>
                                <div>대부업자(그 영업소를 포함한다)의 성명 또는 상호, 주소, 전화번호, 생년월일(성별) 또는 사업자등록번호</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">2.</div>
                                <div>대부업등록번호</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">3.</div>
                                <div>채무자의 성명 또는 상호, 주소, 전화번호, 생년월일(성별) 또는 사업자등록번호</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">4.</div>
                                <div>계약일자</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">5.</div>
                                <div>대부금액</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">6.</div>
                                <div>이자율(이자율의 세부내역 및 연이자율로 환산한 것을 포함)</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">7.</div>
                                <div>연체이자율</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">8.</div>
                                <div>변제기간 및 변제방법</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">9.</div>
                                <div>대부금을 변제받을 은행계좌번호</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">10.</div>
                                <div>채무의 조기상환조건</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">11.</div>
                                <div>부대비용이 있는 경우 그 내용 및 금액</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">12.</div>
                                <div>보증인이 있는 경우 보증인의 성명 또는 상호, 주소, 생년월일(성별) 또는 사업자등록번호, 보증의 내용</div>
                            </div>
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제8조(이자율 등의 제한)</div>
                        <div>
                            ① 대부업자는 관계법령이 정하는 이자율(연체이자율 포함)의 범위 내에서 계약을 체결하기로 한다.<br/>
                            ② 제1항의 규정에 의한 이자율을 산정함에 있어 사례금, 할인금, 수수료, 공제금, 연체이자, 체당금, 그밖에 그 명칭에 불구하고 대부와 관련하여 대부업자가 받는
                            것은 이를 이자로 본다. 다만 당해 거래의 계약체결과 변제에 관한 부대비용으로서 관련 법령이 정한 사항은 그러하지 아니하다.<br/>
                            ③ 대부업자가 제1항의 규정에 의하지 않은 대부계약을 체결한 경우 제1항에 따른 이자율을 초과하는 부분에 대한 이자계약은 무효로 한다.<br/>
                            ④ 채무자가 대부업자에게 제1항에 따른 이자율을 초과하는 이자를 지급한 경우 그 초과 지급된 이자 상당금액은 원본에 충당되고, 원본에 충당되고 남은 금액이 있으면 그
                            반환을 청구할 수 있다.<br/>
                            ⑤ 대부업자가 선이자를 사전에 공제하는 경우에는 그 공제액을 제외하고 채무자가 실제로 받은 금액을 원본으로 하여 제1항에 따른 이자율을 산정한다.<br/>
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제9조(비용의 부담)</div>
                        <div>① 다음 각 호의 비용은 채무자가 부담한다.</div>
                        <div>
                            <div class="flex">
                                <div class="alphabet_align">1.</div>
                                <div>채무자ㆍ보증인에 대한 대부업자의 채권ㆍ담보권 등의 권리의 행사ㆍ보전(해지 포함)에 관한 비용</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">2.</div>
                                <div>채무이행 지체에 따른 독촉 및 통지비용</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">3.</div>
                                <div>채무 및 보증채무와 관련된 증명서의 발급 비용</div>
                            </div>
                        </div>
                        <div>
                            ② 대부업자나 대부업자가 지정하는 자가 제1항 각 호의 업무를 처리하고 그 비용을 채무자에게 청구하는 경우에는 실비를 초과할 수 없으며 소요비용이 최소화되도록 하여야
                            한다.<br/>
                            ③ 제1항에 의한 비용을 대부업자가 대신 지급한 경우에는, 대부업자는 이를 즉시 채무자에게 통지하여 채무자가 이를 곧 변제하도록 하고 만일 채무자가 그러하지 아니하는
                            경우에는 대부업자가 대신 지급한 금액에 대하여, 대신 지급한 날부터 다 갚는 날까지의 날짜수 만큼, 상법 제54조(상사법정이율)에 의한 연 6푼의 범위 내에서
                            약정금리로, 1년을 365일로 보고 1일 단위로 계산한 금액을 더하여 갚기로 한다.<br/>
                            ④ 대부업자는 대부계약 약정 시 채무자가 사전에 알 수 있도록, 약정이자 외에 담보대출에 소요되는 부대비용의 항목과 금액을 알려주어야 한다.
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제10조(계약서의 교부 등)</div>
                        <div>
                            ① 계약내용을 명확히 하기 위하여 계약서는 2부를 작성하여 대부업자와 채무자가 각각 보관하는 것으로 한다.<br/>
                            ② 상환 완료 후 채무자는 대부계약서 및 계약관계서류의 반환을 서면으로 요구할 수 있고, 이의 반환 요청이 있는 경우 대부업자는 대부계약서 및 계약관계서류를 즉시
                            반환하기로 한다.<br/>
                            ③ 인터넷을 통해 전자적인 형태로 대부거래 약정을 체결하는 경우 대부업자는 지체없이 계약서를 전자우편 등으로 채무자에게 송부하고, 계약기간 동안 홈페이지에서 당해
                            계약사항의 열람, 인쇄가 가능하도록 조치하여야 한다. 다만, 채무자의 요청이 있는 경우에는 계약서를 서면으로 교부한다.
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제11조(담보의 제공)</div>
                        <div>채무자 또는 보증인의 신용악화, 제공한 담보의 가치감소의 사유가 발생하여 대부업자가 채권보전상 필요하다고 인정되는 경우에는 채무자는 대부업자의 청구에 의하여
                            대부업자가 인정하는 담보를 제공하거나 보증인을 세우기로 한다. 다만, 담보의 제공이나 보증인을 세울 때에는 반드시 채권보전의 범위 내 이어야 한다.
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제12조(기한의 이익의 상실)</div>
                        <div>① 채무자에게 다음 각 호의 사유가 발생한 경우에는 대부업자로부터의 독촉ㆍ통지 등이 없어도, 채무자는 기한의 이익을 상실한다.</div>
                        <div>
                            <div class="flex">
                                <div class="alphabet_align">1.</div>
                                <div>채무자가 제공한 담보재산에 대하여 압류명령이나 체납처분 압류 통지가 발송된 때 또는 기타의 방법에 의한 강제집행개시나 체납처분착수가 있는 때
                                </div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">2.</div>
                                <div>채무불이행자명부 등재 신청이 있는 때</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">3.</div>
                                <div>어음교환소의 거래정지처분이 있을 때</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">4.</div>
                                <div>도피 또는 기타의 사유로 금융기관에서 채무자에 대한 지급을 정지한 것으로 인정된 때</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">5.</div>
                                <div>파산신청이 있는 때</div>
                            </div>
                        </div>
                        <div>② 채무자에게 다음 각 호의 사유가 발생한 경우에는 기한의 이익을 상실한다. 다만, 대부업자는 기한의 이익상실일 7영업일전까지 다음 각 호의 채무이행지체사실과 이에
                            따라 기한의 이익이 상실된다는 사실을 채무자에게 통지하여야 하며, 기한의 이익상실일 7영업일전까지 통지하지 않은 경우에는 채무자는 실제통지가 도달한 날부터 7영업일이
                            경과한 날에 기한의 이익을 상실한다.
                        </div>
                        <div>
                            <div class="flex">
                                <div class="alphabet_align">1.</div>
                                <div>이자를 지급하여야 할 때부터 2개월간 지체한 때</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">2.</div>
                                <div>분할상환금 또는 분할상환원리금의 지급을 2회 이상 연속하여 지체하고 그 금액이 대출금의 10분의1을 초과하는 경우</div>
                            </div>
                        </div>
                        <div>
                            ③ 채무자에 관하여 다음 각 호에서 정한 사유중 하나라도 발생하여 대부업자의 채권보전에 현저한 위험이 예상될 경우, 대부업자는 서면으로 당해 위험 및 신용의 회복
                            등을 독촉하고, 그 통지의 도달일부터 10영업일 이상으로 대부업자가 정한 기간이 경과하면, 채무자는 대부업자에 대한 당해 채무의 기한의 이익을 상실하여 곧 이를
                            갚아야 할 의무를 진다.
                        </div>
                        <div>
                            <div class="flex">
                                <div class="alphabet_align">1.</div>
                                <div>채무자와 그의 보증인이 대출금을 수령한 후 당초 제출하기로 약속한 대부계약에 필요한 중요서류(대출계약서, 보증계약서 등)를 30일 이내에 제출하지
                                    않을 때
                                </div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">2.</div>
                                <div>채무자가 채무의 상환을 거부하는 의사를 명시적으로 표시할 때</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">3.</div>
                                <div>채무자 및 보증인이 계약서의 주요한 내용을 허위로 기재하거나 제출한 증빙서류가 위변조된 것으로 확인된 때</div>
                            </div>
                        </div>
                        <div>
                            ④ 제1항 내지 제3항에 의하여 채무자가 대부업자에 대한 채무의 기한의 이익을 상실한 경우라도, 대부업자의 명시적 의사표시가 있거나, 대부업자가
                            분할상환금ㆍ이자ㆍ지연배상금을 받는 등 정상적인 거래의 계속이 있는 때에는, 그 채무 또는 대부업자가 지정하는 채무의 기한의 이익은 그 때부터 부활되는 것으로 본다.
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제13조(기한전의 임의 상환 등)</div>
                        <div>채무자는 약정한 상환기일이 도래하기 전이라도 미리 아무런 부담 없이 원금의 전부 또는 일부를 상환할 수 있다. 그러나 대부계약 체결 시 채무자와 기한전의 임의
                            변제로 대부업자가 받을 손해에 대하여 미리 약정한 경우에 한하여 수수료 등을 채무자가 부담한다.
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제14조(채무의 변제 등의 충당)</div>
                        <div>
                            ① 채무자의 채무변제시 채무 전액을 소멸시키기에 부족한 때에는 비용, 이자, 원금의 순서로 충당하기로 한다. 그러나 대부업자는 채무자에게 불리하지 않은 범위 내에서
                            충당순서를 달리할 수 있으나 채무자에게 이러한 사실을 서면으로 통지하여야 한다.<br/>
                            ② 변제될 채무가 수개인 경우로서 채무전액이 변제되지 않을 경우 강제집행 또는 담보권 실행경매에 의한 회수금에 대하여는 민법 기타 법률이 정하는 바에
                            따른다.<br/>
                            ③ 변제될 채무가 수개인 경우로서 제2항에 해당되지 않는 임의의 상환금으로 채무자의 채무전액을 없애기에 부족한 때에는 채무자가 지정하는 순서에 따라 변제에 충당하기로
                            한다. 이 경우, 채무자가 지정하는 순서에 따를 경우, 대부업자의 채권보전에 지장이 생길 염려가 있는 때에는 대부업자는 지체없이 이의를 표시하고, 물적담보나 보증의
                            유무, 그 경중이나 처분의 난이, 변제기의 장단 등을 고려하여 대부업자가 변제에 충당할 채무를 바꾸어 지정할 수 있으나 채무자에게 이러한 사실을 서면으로 통지하여야
                            한다.<br/>
                            ④ 대부업자가 변제충당순서를 제3항에 따라 민법 기타 법률이 정하는바와 달리할 경우에는 대부업자의 채권보전에 지장이 없는 범위 내에서 채무자와 담보제공자 및 보증인의
                            정당한 이익을 고려하여야 한다.
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제15조(영수증 등 서면교부)</div>
                        <div>대부업자는 채무자로부터 이자, 원금 등을 수령한 경우에는 영수증 및 대출잔액 확인서를 서면 또는 전자우편 등으로 교부하여야 한다.</div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제16조(통지사항 및 효력)</div>
                        <div>
                            ① 채무자는 주소, 전화번호, 근무처가 변경된(휴․퇴직 또는 해고되거나 전․폐업한 경우포함) 경우 서면으로 대부업자에게 곧 통지하여야 한다.<br/>
                            ② 채무자가 제1항에 의한 통지를 게을리 하여 대부업자가 발송한 서면통지 또는 기타서류가 채무자에게 연착하거나 도달되지 않은 때에는 보통의 우송기간이 경과한 때에
                            도달한 것으로 본다. 이 경우 상계통지나 기한전의 채무변제 청구 등 중요한 의사표시는 반드시 배달증명부 내용증명에 의하여야 하며, 배달증명부 내용증명이 아닌 경우에는
                            도달한 것으로 보지 않고 다만 추정한다.<br/>
                            ③ 대부업자는 주소 및 전화번호가 변경된 경우 이를 채무자에게 서면으로 통지하여야 한다.
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제17조(채권양도)</div>
                        <div>대부업자는 본 계약서상의 채권을 제3자에게 양도할 수는 있으나, 채권양도에 관하여는 반드시 사전에 채무자 및 보증인에게 동의를 얻어야 한다.</div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제18조(신용정보)</div>
                        <div>
                            ① 채무자가 제공한 신용정보(성명, 생년월일, 주소 등 본인의 특정정보 및 차입내용, 상환사항, 연체 등의 객관적 정보)는 이 계약에 의한 법적인 권리행사를 위해서만
                            이용할 수 있다.<br/>
                            ② 채무자 및 보증인은 그 주소지의 확인을 위하여 대부업자의 채권보전 등의 목적에 따라 개인별 주민등록표의 열람을 승낙하기로 한다.<br/>
                            ③ 대부업자는 채무자 본인과 보증인에 대하여만 개인정보를 요구할 수 있다.
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제19조(이행장소ㆍ준거법)</div>
                        <div>
                            ① 채무의 이행장소는 다른 약정이 없는 한 거래 영업점으로 하고, 송금방법은 대부업자의 은행계좌에 입금하는 것을 원칙으로 한다. 다만, 부실채권의 관리 등 상당한
                            사유로 채권관리업무를 대부업자의 본점ㆍ지역본부 또는 다른 영업점으로 이관한 경우에는, 이관 받은 본점ㆍ지역본부 또는 다른 영업점을 그 이행장소로 한다.<br/>
                            ② 채무자가 내국인이 아닌 경우라도, 이 약관에 의한 대부거래에 관하여 적용될 법률은 국내법을 적용한다.
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제20조(불법적 채권추심 행위의 금지)</div>
                        <div>① 대부업자(대부업자로부터 대부계약에 따른 채권을 양도 받거나 채권의 추심을 위탁받은 자를 포함한다)는 대부거래 계약에 따른 채권을 추심함에 있어서 다음 각 호의
                            방법을 사용하지 않기로 한다.
                        </div>
                        <div>
                            <div class="flex">
                                <div class="alphabet_align">1.</div>
                                <div>채무자 또는 관계인을 폭행․협박․체포 또는 감금하거나 그에게 위계나 위력을 사용하는 행위</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">2.</div>
                                <div>정당한 사유없이 반복적으로 또는 야간(오후 9시 이후부터 다음날 오전 8시까지를 말한다)에 채무자나 관계인을 방문함으로써 공포심이나 불안감을 유발하여
                                    사생활 또는 업무의 평온을 심하게 해치는 행위
                                </div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">3.</div>
                                <div>정당한 사유없이 반복적으로 또는 야간에 전화하는 등 말․글․음향․영상 또는 물건을 채무자나 관계인에게 도달하게 함으로써 공포심이나 불안감을 유발하여
                                    사생활 또는 업무의 평온을 심하게 해치는 행위
                                </div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">4.</div>
                                <div>채무자 외의 사람(보증인을 포함한다)에게 채무에 관한 거짓 사실을 알리는 행위</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">5.</div>
                                <div>채무자 또는 관계인에게 금전의 차용이나 그 밖의 이와 유사한 방법으로 채무의 변제자금을 마련할 것을 강요함으로써 공포심이나 불안감을 유발하여 사생활
                                    또는 업무의 평온을 심하게 해치는 행위
                                </div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">6.</div>
                                <div>채무를 변제할 법률상 의무가 없는 채무자 외의 사람에게 채무자를 대신하여 채무를 변제할 것을 반복적으로 요구함으로써 공포심이나 불안감을 유발하여
                                    사생활 또는 업무의 평온을 심하게 해치는 행위
                                </div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">7.</div>
                                <div>엽서에 의한 채무변제요구 등 채무자 외의 자가 채무사실을 알 수 있게 하는 행위</div>
                            </div>
                            <div class="flex">
                                <div class="alphabet_align">8.</div>
                                <div>채무자의 연락두절 등 소재파악이 곤란한 경우가 아님에도 채무자의 관계인에게 채무자의 소재, 연락처 또는 소재를 알 수 있는 방법 등을 문의하는
                                    행위
                                </div>
                            </div>
                        </div>
                        <div>② 대부업자는 기타 「채권의 공정한 추심에 관한 법률」에서 채권추심과 관련하여 금지하고 있는 행위를 하여서는 아니 된다.</div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title"></div>
                        <div></div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제21조(담보물 처분 전 사전통지)</div>
                        <div>대부업자는 약정 대부기간이 만료되거나 계약이 종료된 이후 담보물을 처분하고자 하는 경우에는 채무자 또는 소유자에게 미리 그 사항을 통지하여야 한다. 단, 법원의
                            경매절차가 개시되어 채무자 또는 소유자에게 별도의 통지가 이루어진 경우에는 이로 갈음할 수 있다.
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제22조(약관의 변경)</div>
                        <div>
                            ① 대부업자가 이 약관을 변경하고자 할 경우, 채무자에게 불리한 내용이 될 때에는 서면통지의 방법으로 이를 알리고, 채무자에게 불리한 내용이 아닌 경우에는
                            거래영업점에 게시함으로써 이를 알려야 한다. 그러나 서면통지나 게시의 경우에는 반드시 제2항의 뜻을 명시하여야 한다.<br/>
                            ② 통지가 도달한 때 또는 게시한 때부터 1개월 이내에 채무자의 서면에 의한 이의가 대부업자에게 도달하지 않은 때에는, 약관의 변경을 승인한 것으로 본다.
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제23조(규정의 준용)</div>
                        <div>① 대부업자가 이 약관을 변경하고자 할 경우, 채무자에게 불리한 내용이 될 때에는 서면통지의 방법으로 이를 알리고, 채무자에게 불리한 내용이 아닌 경우에는
                            거래영업점에 게시함으로써 이를 알려야 한다. 그러나 서면통지나 게시의 경우에는 반드시 제2항의 뜻을 명시하여야 한다.
                        </div>
                    </article>

                    <article class="terms_article">
                        <div class="terms_title">제24조(관할법원의 합의)</div>
                        <div>이 약관에 의한 대부거래 계약에 관하여 대부업자와 채무자 사이에 소송의 필요가 생긴 때에는 법이 정하는 관할법원과 아울러 대부업자의 거래영업점 소재지 지방법원을
                            관할법원으로 하기로 한다. 다만, 채무자의 책임있는 사유로 부실채권이 발생되어 그 채권의 관리를 위하여 대부업자가 본점, 지역본부 또는 다른 영업점으로 그
                            채권관리업무를 이관한 경우에는 법이 정하는 관할법원과 아울러 이관 받은 본점, 지역본부 또는 다른 영업점 소재지 지방법원을 관할법원으로 하기로 한다.
                        </div>
                    </article>


                </section>

                <!-- main에 bottom_btn_case 추가필요 -->
                <section class="bottomBtn_wrap">
                    <BottomBtn>
                        <button
                            slot="bottom_btn"
                            class="primary_btn"
                            :class="{ active: activeBtn }"
                            :disabled="!activeBtn"
                            @click="closeStandardizedAgreement()"
                        >
                            확인
                        </button>
                    </BottomBtn>
                </section>

            </main>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        window.scrollTo(0, 0);
    },
    methods: {
        closeStandardizedAgreement() {
            this.$emit('close')
        },
    },
}
</script>

<style>

</style>